import { render, staticRenderFns } from "./changeFundList.vue?vue&type=template&id=a28b83ca"
import script from "./changeFundList.vue?vue&type=script&lang=js"
export * from "./changeFundList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports